import { ChangeDetectorRef, Component, ElementRef, HostListener, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignupuserService } from '../../services/signupuser.service'
import { OktaAuth } from '@okta/okta-auth-js';
import { AuthService } from '../../services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Route } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';
import { ActivatedRoute, Router } from '@angular/router';

import {
  ChangeDetectionStrategy,
  OnInit,
  inject,
  PLATFORM_ID,
} from "@angular/core";
import {
  FormArray,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";

import { isPlatformServer } from "@angular/common";

import {
  TuiButton,
  TuiIcon,
  TuiLabel,
  TuiLink,
  TuiTitle,
} from "@taiga-ui/core";
import {
  TuiProgressBar,
  TuiFieldErrorPipe,
  TuiCheckbox,
  TuiFilterByInputPipe,
  TuiFiles,
} from "@taiga-ui/kit";

import {
  TuiError,
  TuiDataList,
  TuiAppearance,
  TuiRoot,
  TuiTextfield,
  TuiDropdown,
} from "@taiga-ui/core";
import {
  TuiDataListWrapper,
  TuiRadio,
  TuiAvatar,
  TuiBadge,
  TuiItemsWithMore,
  TuiProgress,
  TuiBadgedContent,
  TuiTabs,
  TuiInputNumber,
} from "@taiga-ui/kit";

import {
  TuiInputDateModule,
  TuiInputModule,
  TuiInputPhoneModule,
  TuiInputSliderModule,
  TuiInputTimeModule,
  TuiSelectModule,
  TuiTextfieldControllerModule,
  TuiTextareaModule,
  TuiInputTagModule,
  TuiComboBoxModule,
  TuiMultiSelectModule,
  TuiInputDateTimeModule,
  TuiInputNumberModule,
} from "@taiga-ui/legacy";

import { TUI_IS_E2E, TuiDay } from "@taiga-ui/cdk";
import { AsyncPipe } from "@angular/common";
import { of, timer, takeWhile, share, repeat, map } from "rxjs";
import { NG_EVENT_PLUGINS } from "@taiga-ui/event-plugins";

@Component({
  selector: 'app-header',
  standalone: true,

  imports: [ReactiveFormsModule,
    CommonModule,
    AsyncPipe,
    TuiProgressBar,
    TuiButton,
    TuiDropdown,
    TuiLabel,
    TuiFieldErrorPipe,
    TuiError,
    TuiDataList,
    TuiAppearance,
    TuiRadio,
    TuiInputDateModule,
    TuiTextfield,
    TuiTextfieldControllerModule,
    TuiInputModule,
    TuiInputNumber,
    TuiInputPhoneModule,
    TuiInputTimeModule,
    TuiSelectModule,
    TuiTextareaModule,
    TuiCheckbox,
    TuiAvatar,
    TuiInputTagModule,
    TuiIcon,
    TuiProgress,
    TuiFilterByInputPipe,
    TuiFiles,
    TuiComboBoxModule,
    TuiMultiSelectModule,
    TuiBadgedContent,
    TuiDataListWrapper,
    TuiInputNumberModule,
    TuiInputSliderModule,
    TuiTextfieldControllerModule,
    TuiItemsWithMore,
    TuiTabs,
    FormsModule,
    TuiTitle,
    TuiInputDateTimeModule,
    TuiLink,
    TuiRoot],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  providers: [NG_EVENT_PLUGINS],
  //changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  isLoggedIn: Boolean = false;
  userDetails: any;
  userDetails1: any;
  isEnrollmentClosed: boolean = false;
  currentMobileStep:number =1;
  currentStep: number = 1;
  currentSurveyStep: number = 1;
  hideSteps: boolean = true;
  steps = [
    {
      id: 1,
      title: "Program Enrollment",
      image: "../assets/Program-Enroll.svg",
      status:""
    },
    {
      id: 2,
      title: "Application Check In",
      image: "../assets/App-Check-In.svg",
      heading: "Storen Application Check In",
      subheading: "How are things going so far?",
      status:""
    },
    {
      id: 3,
      title: "Satisfaction Survey",
      image: "../assets/Satisfaction-Survey.svg",
      heading: "Take the Satisfaction Survey",
      subheading: "Your input matters.",
      status:""
    },
    {
      id: 4,
      title: "Clean Row Photos",
      image: "../assets/Clean-Row-Photos.svg",
      heading: "Upload Storen Clean Row Photos",
      subheading: "Show us your Clean Rows and Clear Results. Upload photo(s) of a Storen field treated with Storen.",
      status:""
    },
    {
      id: 5,
      title: "End-of-Season Survey",
      image: "../assets/End-Season-Survey.svg",
      heading: "End-of-Season Survey",
      subheading: "We hope you had a positive experience with Storen this season. Take this survey and earn a Storen-branded hat or beanie.",
      status:""
    },
    {
      id: 6,
      title: "Program Complete",
      image: "../assets/Program-Complete.svg",
      heading: "End-of-Season Survey",
      subheading: "",
      status:""
    },
  ];
  endOfSeasonSurveyStatus: any;
  applicationLockSatus: any
  satisfactionSurveyStatus: any;
  cleanRowPhotosStatus: any;
  isNavCollapsed = true;
  submenuOpen = false;
  mobileMenuOpen = false;

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event): void {
    const dropdownMenu = document.querySelector('.dropdown-menu');
    const profileToggle = document.querySelector('.account-hover');
    const mobileMenu = document.getElementById('navbarMenu');
    const mobileToggle = document.querySelector('.navbar-toggler');
    if (!this.eRef.nativeElement.contains(event.target) ||
      (dropdownMenu && !dropdownMenu.contains(event.target as Node) &&
        profileToggle && !profileToggle.contains(event.target as Node))) {
      this.submenuOpen = false;
    }

    if (mobileMenu && mobileToggle &&
      !mobileMenu.contains(event.target as Node) &&
      !mobileToggle.contains(event.target as Node)) {
      this.mobileMenuOpen = false;
      this.isNavCollapsed = true;
    }

    

  }

  constructor(private eRef: ElementRef, private title: Title, private userService: SignupuserService, @Inject(OKTA_AUTH) public oktaAuth: OktaAuth, private authService: AuthService, private signUpservice: SignupuserService, private spinner: NgxSpinnerService, private route: Router,private cdr:ChangeDetectorRef) {
  }

  ngOnInit() {
    this.route.events.subscribe((val) => {
      if (this.route.url === "/enrollment-close") {
        this.isEnrollmentClosed = true;
      } else {
        this.isEnrollmentClosed = false;
      }
      if (this.route.url == '/program') {
        this.currentSurveyStep = 1;
        this.currentStep = 1;
        this.currentMobileStep = 1;
        this.hideSteps = false;
      }
      else if (this.route.url == '/application-checkin') {
        this.currentSurveyStep = 2;
        this.currentStep = 2;
        this.currentMobileStep = 2;
        this.hideSteps = false;
      } else if (this.route.url == '/satisfaction-survey') {
        this.currentSurveyStep = 3;
        this.currentStep = 3;
        this.currentMobileStep = 3;
        this.hideSteps = false;
      } else if (this.route.url == '/clean-row-photos') {
        this.currentSurveyStep = 4;
        this.currentMobileStep =4;
        this.currentStep = 4;
        this.hideSteps = false;
      } else if (this.route.url == '/end-of-season-survey') {
        this.currentSurveyStep = 5;
        this.currentStep = 5;
        this.currentMobileStep = 5;
        this.hideSteps = false;
      } else if (this.route.url == '/program-complete') {
        this.currentSurveyStep = 6;
        this.currentStep = 6;
        this.currentMobileStep = 6;
        this.hideSteps = false;
      } else if (this.route.url == '/program') {
        this.hideSteps = false;
      } else {
        this.hideSteps = true;
      }

    });

    const signup = this.signUpservice.dynamicText$.subscribe(text => {
      const userDetailsCookie = document.cookie.split(';').find(cookie => cookie.trim().startsWith('userDetails='));
      if (userDetailsCookie) {
        const userDetailsString = userDetailsCookie.split('=')[1];
        this.userDetails = JSON.parse(decodeURIComponent(userDetailsString));
        this.isLoggedIn = this.userDetails.loggedIn;
      }
    });

  }
  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }
  toggleNav(): void {
    
    this.isNavCollapsed = !this.isNavCollapsed;
  }

  toggleDropdown(): void {
    this.submenuOpen = !this.submenuOpen;
  }

  toggleMobileMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }
  signOut() {
    document.cookie = 'userDetails=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    sessionStorage.clear();
    this.authService.logout();
    this.isLoggedIn = false;
    this.userDetails.loggedIn = false;
    this.submenuOpen = false;
    this.mobileMenuOpen = false;
    this.route.navigate(['/log-in'])
  }
  redirectHome(){
    this.authService.checkAuthAndRedirectHome();
  }
  getStepImage(stepId: number): string {
     // if (this.route.url == '/program') {
        this.applicationLockSatus = sessionStorage.getItem("applicationLockSatus");
        this.satisfactionSurveyStatus = sessionStorage.getItem("satisfactionSurveyStatus");
        this.cleanRowPhotosStatus = sessionStorage.getItem("cleanRowPhotosStatus");
        this.endOfSeasonSurveyStatus = sessionStorage.getItem("endOfSeasonSurveyStatus");
        if(this.endOfSeasonSurveyStatus == 'COMPLETED' && this.cleanRowPhotosStatus == 'COMPLETED' && this.satisfactionSurveyStatus == 'COMPLETED' && this.applicationLockSatus == 'COMPLETED'){
         this.currentMobileStep = 6;
         this.currentStep = 6;
          this.steps.forEach((item:any)=>{
            item.status = 'COMPLETED'
          })
        }else {
          if(this.endOfSeasonSurveyStatus == 'COMPLETED' || this.cleanRowPhotosStatus == 'COMPLETED' || this.satisfactionSurveyStatus == 'COMPLETED' || this.applicationLockSatus == 'COMPLETED'){
           this.steps[0].status = 'COMPLETED';
          }
          if (this.applicationLockSatus == 'COMPLETED') {
            this.currentMobileStep = 2;
            this.steps[1].status = 'COMPLETED';
          }
          if (this.satisfactionSurveyStatus == 'COMPLETED') {
            this.currentMobileStep = 3;
            this.steps[2].status = 'COMPLETED';
          } 
          if (this.cleanRowPhotosStatus == 'COMPLETED') {
            this.currentMobileStep = 4;
            this.steps[3].status = 'COMPLETED';
          } 
        if (this.endOfSeasonSurveyStatus == 'COMPLETED') {
          this.currentMobileStep = 5;
          this.steps[4].status = 'COMPLETED';
        }  
      }
      if (this.route.url == '/program') {
        if(this.endOfSeasonSurveyStatus == 'COMPLETED' && this.cleanRowPhotosStatus == 'COMPLETED' && this.satisfactionSurveyStatus == 'COMPLETED' && this.applicationLockSatus == 'COMPLETED'){
          this.currentStep = 6;
        }
        else if (this.endOfSeasonSurveyStatus == 'COMPLETED') {
          this.currentStep = 5;
        } else if  (this.cleanRowPhotosStatus == 'COMPLETED') {
          this.currentStep = 4;
        }else  if (this.satisfactionSurveyStatus == 'COMPLETED') {
          this.currentStep = 3;
        } 
        else if (this.applicationLockSatus == 'COMPLETED') {
          this.currentStep = 2;
        }  
       
      }
    if (this.currentStep === stepId) {
      return this.steps.find((step) => step.id === stepId)?.image || "";
    } else if (stepId>=1 && this.steps[stepId-1].status=='COMPLETED') {
      return "/assets/Vector-yellow.svg";
    } else {
      return "/assets/Vector-blue.svg";
    }
  }


}
